import fields from '../constants/field-names';

const normalizeName = value => value.toLowerCase();

const normalizeDate = value => value;

const normalizeByField = {
  [fields.NAME]: normalizeName,
  [fields.DATE]: normalizeDate
};

export default normalizeByField;